/* eslint-disable no-undef */
export default {
	name: "orders-delivery-dashboard",
	data() {
		return {
			recentDeliveryOrders: [],
			orderStatuses: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			report:{
				startDate: null,
				endDate: null
			},
			initialiseDatePicker: true,
			initialiseDatePickerEndDate: true,
			deliveryOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Expected Date Of Delivery",
					field: "expectedDeliveryDate"
				},
				{
					text: "Vehicle",
					field: "vehicle"
				},
				// {
				// 	text: "Amount Ordered",
				// 	field: "quantity"
				// },
				// {
				// 	text: "Amount Dispensed",
				// 	field: "quantityDispensed"
				// },
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "description"
				}
			],
			actionKeys:{
				viewOrder: "viewOrder"
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: 1,
				companyId: null,
				orderStatusId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			hasLoaded: false,
			loading: false,
			errorMessage: null
		};
	},
	methods: {
		getRecentDeliveryOrders(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				orderStatusId: this.filter.orderStatusId,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
			};
			orderService.getRecentDeliveryOrders(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.recentDeliveryOrders = successResponse.data.result;
						for(let i = 0; i < this.recentDeliveryOrders.length; i++){
							this.recentDeliveryOrders[i].totalAsString = currencyHelper.numberToCurrency(this.recentDeliveryOrders[i].totalAmount);
							this.recentDeliveryOrders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnDeliveryOrdersDashboardViewOrder"
								}
							];
						}
						this.recentDeliveryOrders = dataTableHelper.castFieldValues(this.recentDeliveryOrders);
						this.hasLoaded = true;
						this.filterStateChanged = false;
						//permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderStatuses(){
			this.orderStatuses = orderService.getDeliveryOrderStatuses();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({
				id: 0,
				text: "All"
			});
			this.filter.orderStatusId = 0;
			this.getRecentDeliveryOrders();
		},
		onFilterSearchClicked(){
			this.getRecentDeliveryOrders();
		},
		onOrderStatusSelect(orderStatus){
			if(orderStatus.id !== this.filter.orderStatusId){
				this.filter.orderStatusId = orderStatus.id;
				this.filterStateChanged = true;
			}
			//this.filter.orderStatusId = orderStatus.id;
			console.log("order status change");
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
		},
		onOrderActionClicked(actionAndData){
			switch(actionAndData.action) {
				case this.actionKeys.viewOrder:
					this.$router.push("/orders/viewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId);
					break;
			}
		},
		onFromReportDateSelect(date){
			this.report.startDate = date;
			this.initialiseDatePicker = false;
		},
		onToReportDateSelect(date){
			this.report.endDate = date;
			this.initialiseDatePickerEndDate = false;
		},
		checkReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportDeliveryVarianceReport();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "DeliveryVarianceReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
		this.filter.orderStatusId = orderHelper.orderStatus.pending;
		this.getOrderStatuses();
		storeState.setPageTitleAction("Recent Orders - Delivery");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Recent Orders - Delivery");
	}
};